import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RegisteredUserConfigurationApiService {

  constructor(private http: HttpClient) {}

  readonly registeredUserConfigurationUrl: string = 'configuration/registeredUsers';

  public getRegisteredUsersConfiguration(): Promise<any> {
    return this.http.get(this.registeredUserConfigurationUrl).toPromise();
  }

  public updateRegisteredUsersConfiguration(configuration): Promise<any> {
    return this.http.put(this.registeredUserConfigurationUrl, configuration).toPromise();
  }
}
